/** Public URL for an object stored in the private `content-images` bucket. */
export function mediaUrl(pathOrUrl: string | null | undefined): string | undefined {
  if (!pathOrUrl) return undefined;
  if (/^https?:\/\//i.test(pathOrUrl) || pathOrUrl.startsWith("/")) return pathOrUrl;
  return `/api/public/media/${pathOrUrl.split("/").map(encodeURIComponent).join("/")}`;
}

/**
 * Normalize a CMS cover value to a servable URL.
 * Accepts absolute URLs, `/api/public/media/...` paths and bare storage paths.
 */
export function normalizeMediaUrl(value: string | null | undefined): string | undefined {
  if (!value) return undefined;
  const v = value.trim();
  if (!v) return undefined;
  if (/^https?:\/\//i.test(v)) return v;
  if (v.startsWith("/api/public/media/")) return v;
  if (v.startsWith("/")) return v;
  return `/api/public/media/${v.replace(/^\/+/, "")}`;
}
